import { IDataProviderFilter, StaticFilterService } from 'core-components/types'

export const filterData = <T>(
  filter: IDataProviderFilter,
  currentData: T[],
  availableData: T[]
) => {
  if (!filter.filters.length) {
    return currentData
  }
  const parentFilter = {
    resultData: [],
    ...filter,
    availableData,
  }
  StaticFilterService.filterData(filter.filters, currentData, parentFilter)
  return parentFilter.resultData
}
